export function getQueryParams(locationSearch: string): { [key: string]: string | string[] } | void {
	const params = new URLSearchParams(locationSearch);

	if (!locationSearch) return console.warn('argument locationSearch in getQueryParams:', locationSearch);

	const result: { [key: string]: string | string[] } = {};

	const arrParams = params.toString().split(/[?&]/);
	arrParams.forEach((param) => {
		const [key, value]: string[] = param.split('=');
		if (key in result) {
			if (typeof result[key] === 'string') {
				result[key] = [result[key] as unknown as string];
			}

			result[key] = [...(result[key] as unknown as []), value];
			return;
		}
		result[key] = value;
	});

	return result;
}
